import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PluginService, AlertService} from '../../../services';
import {CustomerService} from '../../../services/models';
import {BaseEditComponent} from '../../base/base.edit.component';

@Component({
  templateUrl: './customer.edit.component.html',
  selector: 'customer-edit'
})

export class CustomerEditComponent extends BaseEditComponent implements OnInit {

  record: any = null;
  dealerForm: FormGroup;
  @Input() id: any = null;
  @Output() close = new EventEmitter();

  constructor(
    private router: Router,
    private customerService: CustomerService,
    protected pluginService: PluginService,
    private formBuilder: FormBuilder,
    protected alertService: AlertService
  ) {
    super(pluginService);
  }

  ngOnInit() {
    this.dealerForm = this.formBuilder.group({
      name: [''],
      address: [''],
      email: [''],
      phone: [''],
      questions: [''],
      proof_purchase: [''],
      opt_in: [''],
      created_at: [''],
    });

    if (this.id != 'new') {
      this.customerService.getRecord(this.id)
        .subscribe(
          data => {
            this.record = data.data;
          },
          error => {

          });
    } else {
      this.record = {}
    }

  }

  cancel() {
    this.close.emit();
  }
}
